import { render, staticRenderFns } from "./freightOrder.vue?vue&type=template&id=19cdeeec&scoped=true&"
import script from "./freightOrder.vue?vue&type=script&lang=ts&"
export * from "./freightOrder.vue?vue&type=script&lang=ts&"
import style0 from "./freightOrder.vue?vue&type=style&index=0&id=19cdeeec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdeeec",
  null
  
)

export default component.exports